export class FieldLevelError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'FieldLevelError'
  }
}
